import { Component } from '@angular/core';

@Component({
  selector: 'app-caret-icon',
  templateUrl: './caret-icon.component.html',
  styleUrls: ['./caret-icon.component.scss']
})
export class CaretIconComponent {

}
